<header class="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
  [ngClass]="isScrolled ? 'header-floating' : ''">

  <!-- Top Utility Bar -->
  <div
    class="hidden lg:block transition-all duration-300 border-b topbar-wrapper"
    [ngClass]="isScrolled ? 'topbar-hidden' : 'bg-transparent border-white/10'"
    [class.topbar-dropdown-open]="isLangDropdownOpen"
  >
    <div class="container-custom flex items-center justify-end gap-6 px-4 lg:px-16 h-9">
      @for (link of topLinkConfig; track link.key) {
        <a
          [href]="link.href"
          class="text-xs font-medium transition-colors duration-300 flex items-center gap-1 top-link-light"
        >
          {{ i18n.content().header[link.key] }}
          @if (link.external) {
            <i class="pi pi-arrow-up-right text-[10px]"></i>
          }
        </a>
      }

      <!-- Language Switcher -->
      <div class="relative lang-dropdown">
        <button
          type="button"
          class="flex items-center gap-1.5 text-xs font-medium transition-colors duration-300 top-link-light"
          (click)="toggleLangDropdown($event)"
        >
          <i class="pi pi-globe text-xs"></i>
          {{ i18n.getLanguageLabel(i18n.currentLang()) }}
          <i class="pi pi-chevron-down text-[9px] transition-transform duration-200"
             [ngClass]="isLangDropdownOpen ? 'rotate-180' : ''"></i>
        </button>

        @if (isLangDropdownOpen) {
          <div class="lang-dropdown-menu animate-dropdown">
            @for (lang of i18n.languages; track lang.code) {
              <button
                type="button"
                class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center justify-between"
                [ngClass]="i18n.currentLang() === lang.code ? 'font-semibold text-primary-600' : ''"
                (click)="selectLanguage(lang.code)"
              >
                {{ lang.label }}
                @if (i18n.currentLang() === lang.code) {
                  <i class="pi pi-check text-xs text-primary-600"></i>
                }
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Main Navigation Bar -->
  <div class="nav-bar-wrapper transition-all duration-500"
    [ngClass]="isScrolled ? 'nav-bar-scrolled' : 'bg-transparent'">
    <div class="flex items-center justify-between h-14 px-5">
      <!-- Logo -->
      <a routerLink="/" class="flex items-center gap-2.5 z-10" (click)="goToHomePage($event)">
        <div
          class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors duration-300"
          [ngClass]="isScrolled ? 'bg-primary-600' : 'bg-white'"
        >
          <i
            class="pi pi-eye text-base"
            [ngClass]="isScrolled ? 'text-white' : 'text-primary-600'"
          ></i>
        </div>
        <span
          class="text-lg font-extrabold tracking-tight transition-colors duration-300"
          [ngClass]="isScrolled ? 'text-gray-900' : 'text-white'"
        >
          pupil lab
        </span>
      </a>

      <!-- Desktop Navigation -->
      <nav class="hidden lg:flex items-center gap-0.5">
        @for (link of navLinkConfig; track link.key) {
          @if (link.key === 'company') {
            <div class="relative company-dropdown">
              <button
                type="button"
                class="px-3 py-2 text-sm font-medium transition-colors duration-300 flex items-center gap-1 rounded-md"
                [ngClass]="isScrolled
                  ? (isCompanyDropdownOpen ? 'text-primary-600 bg-gray-50' : 'text-gray-700 hover-text-primary hover-bg-gray-50')
                  : (isCompanyDropdownOpen ? 'text-white bg-white/15' : 'nav-link-light')"
                (click)="toggleCompanyDropdown($event)"
              >
                {{ i18n.content().header.nav[link.key] }}
                <i class="pi pi-chevron-down text-[9px] opacity-60 transition-transform duration-200"
                   [ngClass]="isCompanyDropdownOpen ? 'rotate-180' : ''"></i>
              </button>

              @if (isCompanyDropdownOpen) {
                <div class="nav-dropdown-menu animate-dropdown">
                  <button
                    type="button"
                    class="nav-dropdown-link"
                    (click)="goToAboutPage($event)"
                  >
                    {{ i18n.content().header.about }}
                  </button>
                </div>
              }
            </div>
          } @else {
            <a
              [href]="link.href"
              class="px-3 py-2 text-sm font-medium transition-colors duration-300 flex items-center gap-1 rounded-md"
              [ngClass]="isScrolled ? 'text-gray-700 hover-text-primary hover-bg-gray-50' : 'nav-link-light'"
            >
              {{ i18n.content().header.nav[link.key] }}
              @if (link.hasDropdown) {
                <i class="pi pi-chevron-down text-[9px] opacity-60"></i>
              }
            </a>
          }
        }
      </nav>

      <!-- Desktop Right Actions -->
      <div class="hidden lg:flex items-center gap-2">
        <button
          type="button"
          class="w-9 h-9 rounded-lg flex items-center justify-center transition-colors duration-300"
          [ngClass]="isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover-bg-white-10'"
        >
          <i class="pi pi-search text-sm"></i>
        </button>
        <a
          href="#contact"
          class="px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300"
          [ngClass]="isScrolled ? 'bg-primary-600 text-white hover-bg-primary-dark' : 'bg-white text-gray-900 hover:bg-gray-100'"
        >
          {{ i18n.content().header.contactUs }}
        </a>
      </div>

      <!-- Mobile Menu Button -->
      @if (!isMobileMenuOpen) {
        <button
          type="button"
          class="lg:hidden z-10 p-2 rounded-lg transition-colors"
          [ngClass]="isScrolled ? 'text-gray-700' : 'text-white'"
          (click)="toggleMobileMenu()"
          [attr.aria-label]="i18n.content().header.menu"
        >
          <i class="pi pi-bars text-xl"></i>
        </button>
      }
    </div>
  </div>

  <!-- Mobile Menu Panel -->
  @if (isMobileMenuOpen) {
    <div class="mobile-menu lg:hidden">
      <div class="mobile-menu-header">
        <a routerLink="/" class="flex items-center gap-2.5" (click)="goToHomePage($event)">
          <div class="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center">
            <i class="pi pi-eye text-base text-white"></i>
          </div>
          <span class="text-lg font-extrabold text-gray-900">pupil lab</span>
        </a>
        <button
          type="button"
          class="mobile-menu-close"
          (click)="closeMobileMenu()"
          [attr.aria-label]="i18n.content().header.closeMenu"
        >
          <i class="pi pi-times text-xl"></i>
        </button>
      </div>

      <div class="mobile-menu-content">
        @for (link of navLinkConfig; track link.key) {
          @if (link.key === 'company') {
            <div class="border-b border-gray-100">
              <button
                type="button"
                class="mobile-menu-link w-full text-left"
                (click)="isCompanyDropdownOpen = !isCompanyDropdownOpen"
              >
                <span>{{ i18n.content().header.nav[link.key] }}</span>
                <i class="pi text-xs text-gray-400"
                   [ngClass]="isCompanyDropdownOpen ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
              </button>
              @if (isCompanyDropdownOpen) {
                <button
                  type="button"
                  class="block w-full text-left py-3 pl-4 text-base text-gray-600 hover:text-primary-600"
                  (click)="goToAboutPage($event)"
                >
                  {{ i18n.content().header.about }}
                </button>
              }
            </div>
          } @else {
            <a
              [href]="link.href"
              class="mobile-menu-link"
              (click)="closeMobileMenu()"
            >
              <span>{{ i18n.content().header.nav[link.key] }}</span>
              @if (link.hasDropdown) {
                <i class="pi pi-chevron-right text-xs text-gray-400"></i>
              }
            </a>
          }
        }

        <div class="mt-6 pt-6 border-t border-gray-100">
          <p class="text-sm text-gray-500 mb-3 flex items-center gap-2">
            <i class="pi pi-globe"></i>
            {{ i18n.getLanguageLabel(i18n.currentLang()) }}
          </p>
          <div class="flex flex-wrap gap-2">
            @for (lang of i18n.languages; track lang.code) {
              <button
                type="button"
                class="px-3 py-1.5 rounded-full text-sm border transition-colors"
                [ngClass]="i18n.currentLang() === lang.code ? 'bg-primary-600 text-white border-primary-600' : 'text-gray-600 border-gray-200'"
                (click)="selectLanguage(lang.code)"
              >
                {{ lang.label }}
              </button>
            }
          </div>
        </div>

        <div class="mt-4 flex flex-col gap-2">
          @for (link of topLinkConfig; track link.key) {
            <a [href]="link.href" class="text-sm text-gray-500 py-2" (click)="closeMobileMenu()">
              {{ i18n.content().header[link.key] }}
            </a>
          }
        </div>

        <a
          href="#contact"
          class="mt-8 block bg-primary-600 text-white text-center py-3 rounded-full font-semibold"
          (click)="closeMobileMenu()"
        >
          {{ i18n.content().header.contactUs }}
        </a>
      </div>
    </div>
  }
</header>
